import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@ui/components/ui/button';
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '@ui/components/ui/dialog';

interface ConfirmDeactivateDialogProps {
  open: boolean;
  name: string;
  isPending: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

/**
 * Only this direction asks. Switching somebody back on hands an account back, which is harmless and
 * undoable; switching it off locks the person out of the app they would undo it in.
 */
const ConfirmDeactivateDialog = ({
  open,
  name,
  isPending,
  onCancel,
  onConfirm,
}: ConfirmDeactivateDialogProps): ReactElement => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onOpenChange={isOpen => !isOpen && onCancel()}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>{t('deactivateMember.title')}</DialogTitle>
        </DialogHeader>

        <p className="text-sm text-foreground">{t('deactivateMember.body', { name })}</p>

        <DialogFooter>
          <Button type="button" variant="outline" onClick={onCancel} disabled={isPending}>
            {t('actions.cancel')}
          </Button>
          <Button type="button" onClick={onConfirm} disabled={isPending}>
            {t('actions.deactivate')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ConfirmDeactivateDialog;
